import {Component, OnInit, Inject, ElementRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-field-input-dialog',
    templateUrl: './fieldinputdialog.component.html',
    styleUrls: ['./fieldinputdialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FieldInputDialogComponent {

  title: string;
  label: string;
  value: string;

  public form: UntypedFormGroup;

  constructor(
      private formBuilder: UntypedFormBuilder,
      public dialogRef: MatDialogRef<FieldInputDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: FieldInputDialogModel
  ) {
    this.title = data.title;
    this.label = data.label;
    this.value = data.value;
    this.form = this.formBuilder.group({
          input: new UntypedFormControl(this.value, [Validators.required]),
        }
    );
  }

  onConfirm(): void {
    this.dialogRef.close(this.form.get('input')?.value);
  }

  onDismiss(): void {
    this.dialogRef.close(undefined);
  }
}

export class FieldInputDialogModel {
  constructor(public title: string, public label: string, public value: string) {
  }

}
